export const DashboardNutritionHack = {
  bindings: {
    description: '<',
    items: '<',
    hackId: '<',
    title: '<',
  },

  template: `
    <div class="dashboard-nutrition-hack">
      <dashboard-carousel>
        <dashboard-carousel-header>
          <h4>{{ $ctrl.title }}</h4>
          <p>
            {{ $ctrl.description }}
            <a ui-sref="nutrition.hacks.recipes({ hackId: $ctrl.hackId})">
              Read Article.
            </a>
          </p>
        </dashboard-carousel-header>
        <dashboard-carousel-body>
          <carousel list="$ctrl.items">
            <div class="carousel-slide-wrapper"
              ng-repeat="item in $ctrl.items track by $index">
              <div class="carousel-slide">
                <card-recipe
                  recipe="item"
                  on-click="$ctrl.onClick(item.id)">
                </card-recipe>
              </div>
            </div>
          </carousel>
        </dashboard-carousel-body>
        <dashboard-carousel-footer>
          <a ui-sref="nutrition.hacks">
            View More Tips
          </a>
        </dashboard-carousel-footer>
      </dashboard-carousel>
    </div>`,

  controller($state) {
    'ngInject';

    return {
      onClick(recipeId) {
        $state.go('nutrition.recipes.detail', { recipeId });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/NutritionHack.js